import { normalizeDispatchPeriod, readDispatchDateFromSearch, readDispatchPeriodFromSearch } from "./dispatchDateUrls.js";

// These parameters only select a presentation of the already loaded dispatch.
const PRESENTATION_PARAMS = ["dispatch_month", "detailView", "truck"];

// Ouverture du Dispatch, ou autre journée ou période que celle déjà chargée.
export function isDispatchResultsOpening(search = "", loadedResults = null) {
  return !loadedResults?.dispatch_date
    || readDispatchDateFromSearch(search) !== loadedResults.dispatch_date
    || readDispatchPeriodFromSearch(search) !== normalizeDispatchPeriod(loadedResults.dispatch_period);
}

export function shouldRevalidateDispatchResults({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate = true,
  formMethod,
  actionResult,
  actionStatus,
}, { loadedResults = null, explicitlyRevalidating = false } = {}) {
  if (
    explicitlyRevalidating
    || formMethod
    || actionResult !== undefined
    || actionStatus !== undefined
    || !loadedResults?.dispatch_date
    || currentUrl.pathname !== nextUrl.pathname
    || currentUrl.search === nextUrl.search
  ) {
    return defaultShouldRevalidate;
  }

  const currentParams = new URLSearchParams(currentUrl.search);
  const nextParams = new URLSearchParams(nextUrl.search);
  const loadedDate = loadedResults.dispatch_date;
  const currentDate = currentParams.get("dispatch_date");
  const nextDate = nextParams.get("dispatch_date");
  const loadedPeriod = normalizeDispatchPeriod(loadedResults.dispatch_period);
  if (
    (currentDate && currentDate !== loadedDate)
    || nextDate !== loadedDate
    || readDispatchPeriodFromSearch(currentUrl.search) !== loadedPeriod
    || readDispatchPeriodFromSearch(nextUrl.search) !== loadedPeriod
  ) {
    return defaultShouldRevalidate;
  }

  // ResultsPage makes a bare entry URL explicit once its loader has resolved.
  // Only that exact loaded day may be canonicalized without another fetch.
  if (!currentDate && !currentParams.has("dispatch_date")) {
    currentParams.set("dispatch_date", loadedDate);
  }
  for (const key of PRESENTATION_PARAMS) {
    currentParams.delete(key);
    nextParams.delete(key);
  }
  currentParams.sort();
  nextParams.sort();
  return currentParams.toString() === nextParams.toString()
    ? false
    : defaultShouldRevalidate;
}
